import { Box, Button, Typography } from '@mui/material';
import React from 'react';

interface LibraryPaginationProps {
  currentPage: number;
  totalPages: number;
  onPageChange: (page: number) => void;
}

export const LibraryPagination: React.FC<LibraryPaginationProps> = ({ currentPage, totalPages, onPageChange }) => {
  if (totalPages <= 1) return null;

  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
      <Button
        variant="outlined"
        disabled={currentPage === 1}
        onClick={() => onPageChange(currentPage - 1)}
        sx={{ mx: 1, borderRadius: '10px', textTransform: 'none' }}
      >
        Previous
      </Button>
      <Typography variant="body1" sx={{ mx: 2, display: 'flex', alignItems: 'center' }}>
        Page {currentPage} of {totalPages}
      </Typography>
      <Button
        variant="outlined"
        disabled={currentPage === totalPages}
        onClick={() => onPageChange(currentPage + 1)}
        sx={{ mx: 1, borderRadius: '10px', textTransform: 'none' }}
      >
        Next
      </Button>
    </Box>
  );
};